const fontFamily = {
  base: 'Arial,Helvetica,sans-serif',
};

export default {
  fontFamily,
};
